'use client'

import Link from '@/modules/shared/components/Link'
import { usePathname } from 'next/navigation'

const pathMap: Record<string, string> = {
  'ket-qua-tra-cuu-ma-hs': 'Kết quả tra cứu mã HS',
  'tra-cuu-ma-hs': 'Tra cứu mã HS – Biểu thuế xuất nhập khẩu',
  'chi-tiet-ma-hs': 'Chi tiết mã HS',
  'van-ban-phap-luat': 'Văn bản pháp luật',
  'ban-an': 'Bản án',
  'hop-dong-mau': 'Hợp đồng mẫu',
  'cong-cu': 'Công cụ',
  'bai-viet': 'Bài viết',
  'gioi-thieu': 'Giới thiệu',
  'goi-dich-vu': 'Gói dịch vụ',
  'nang-cap-tai-khoan': 'Nâng cấp tài khoản',
  'huong-dan-thanh-toan': 'Hướng dẫn thanh toán',
  'huong-dan-su-dung': 'Hướng dẫn sử dụng',
  'lien-he': 'Liên hệ',
}

// TODO: Refactor 24/1/2026
export default function BreadCrumb() {
  const pathname = usePathname()

  // Tách path thành các segments
  const segments = pathname.split('/').filter((segment) => segment !== '')

  // Nếu ở trang chủ, không hiển thị breadcrumb
  if (segments.length === 0) {
    return null
  }

  // Check if we're on ket-qua-tra-cuu-ma-hs page
  const isHsResultPage = pathname.includes('ket-qua-tra-cuu-ma-hs')
  const isHsDetailPage = pathname.includes('chi-tiet-ma-hs')
  const hsCode = segments[segments.indexOf('chi-tiet-ma-hs') + 1]

  return (
    <section
      className="content"
      style={{ padding: '0', background: 'transparent' }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <ol
              className="breadcrumb"
            >
              <li>
                <Link href="https://caselaw.vn/" title="Trang chủ" style={{ color: '#0082E0' }}>
                  Trang chủ
                </Link>
              </li>
              {isHsResultPage ? (
                <>
                  <li>
                    <Link
                      href="/tra-cuu-ma-hs"
                      title="Tra cứu mã HS – Biểu thuế xuất nhập khẩu"
                      style={{ color: '#0082E0' }}
                    >
                      Tra cứu mã HS – Biểu thuế xuất nhập khẩu
                    </Link>
                  </li>
                  <li>
                    <span
                      style={{ color: '#535354' }}
                    >
                      Kết quả tra cứu mã HS
                    </span>
                  </li>
                </>
              ) : isHsDetailPage ? (
                <>
                  <li>
                    <Link
                      href="/tra-cuu-ma-hs"
                      title="Tra cứu mã HS – Biểu thuế xuất nhập khẩu"
                      style={{ color: '#0082E0' }}
                    >
                      Tra cứu mã HS – Biểu thuế xuất nhập khẩu
                    </Link>
                  </li>
                  <li>
                    <span style={{ color: '#535354' }}>
                      {!hsCode || hsCode.length < 8
                        ? 'Không tìm thấy'
                        : `Mô tả chi tiết mã HS ${hsCode}`}
                    </span>
                  </li>
                </>
              ) : (
                segments.map((segment, index) => {
                  const path = '/' + segments.slice(0, index + 1).join('/')
                  const isLast = index === segments.length - 1
                  const label = pathMap[segment] || segment

                  return (
                    <li key={path}>
                      {isLast ? (
                        <span style={{ color: '#535354' }}>{label}</span>
                      ) : (
                        <Link href={path} style={{ color: '#002060' }}>
                          {label}
                        </Link>
                      )}
                    </li>
                  )
                })
              )}
            </ol>
          </div>
        </div>
      </div>
    </section>
  )
}
